import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 11,
    width: 22,
    height: 2,
    rx: 1
  }));
});
var NavigationLess = AbstractIcon.withComponent(Icon);
NavigationLess.displayName = 'NavigationLess';
export default NavigationLess;